module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"browser_title":"Sign Up","signup":"Sign Up Information","tab_download_plans":"Download Plans","tab_streaming_plans":"Streaming Plans"},"ja":{"browser_title":"入会案内","signup":"入会のご案内","tab_download_plans":"ダウンロードプラン","tab_streaming_plans":"ストリーミングプラン"}}')
  delete Component.options._Ctor
}
